import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditFixedPage from "../../Components/Admin/AdminEditFixedPage";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditFixedPages = () => {
  return (

    <AdminEditFixedPage />

  );
};

export default AdminEditFixedPages;